import React, { useEffect } from 'react'
import { TaxInfoMessageContent, TaxInfoMessageText, TaxInfoMessageWrap } from './index.styled'
import MainIcon from '../../../img/svg/main'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectCompanyIndex, selectDealerIndex, selectHasAccessToken, selectIsEnd2EndTestCompany } from '../../../redux/selector/system'
import { setShowSystemMessage } from '../../../redux/action/system'
import { blockedDealerNumbers } from '../../../redux/selector/system/constants'

const excludedPathnameForShow = ['/cashdesk', '/delivery', '/delivery/cart', '/restaurant/cart', '/settings/delivery/config', '/driver-monitor']

const TaxInfoMessage = React.memo(() => {
	const hasAccessToken = useSelector(selectHasAccessToken)
	const companyIndex = useSelector(selectCompanyIndex)
	const dealerNumber = useSelector(selectDealerIndex)
	const showSystemMessage = useSelector(store => store.system.showSystemMessage)
	const isEnd2EndTestCompany = useSelector(selectIsEnd2EndTestCompany)
	const location = useLocation()
	const dispatch = useDispatch()
	const isAuthorized = hasAccessToken && companyIndex
	const isCorrectPath = !excludedPathnameForShow.includes(location.pathname)
	const isTargetCompany = blockedDealerNumbers.includes(dealerNumber)
	const showTaxInfoMessageCondition = isAuthorized && !isEnd2EndTestCompany && isCorrectPath && isTargetCompany

	useEffect(() => {
		if (showSystemMessage !== showTaxInfoMessageCondition) {
			dispatch(setShowSystemMessage(showTaxInfoMessageCondition))
		}
	}, [showSystemMessage, showTaxInfoMessageCondition]) // eslint-disable-line react-hooks/exhaustive-deps

	return (showSystemMessage &&
		<TaxInfoMessageWrap>
			<TaxInfoMessageContent>
				<MainIcon icon="info" />
				<TaxInfoMessageText><strong>Wichtige Information:</strong> Ihr Liefersoft-System funktioniert weiterhin wie gewohnt. Bei Fragen oder abweichenden Informationen kontaktieren Sie bitte direkt uns: +49 511 546 814 14</TaxInfoMessageText>
			</TaxInfoMessageContent>
		</TaxInfoMessageWrap>
	)
})

TaxInfoMessage.displayName = 'TaxInfoMessage'
export default TaxInfoMessage
